"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidServiceDefinitionError = void 0;
class InvalidServiceDefinitionError extends Error {
    constructor() {
        super(`InvalidServiceDefinitionError`);
        Object.setPrototypeOf(this, InvalidServiceDefinitionError.prototype);
    }
}
exports.InvalidServiceDefinitionError = InvalidServiceDefinitionError;
//# sourceMappingURL=InvalidServiceDefinitionError.js.map